import {
  AFFILIATES_FAILURE,
  AFFILIATES_REQUEST,
  AFFILIATES_SUCCESS,
} from "../login/api.actions";
import {
  CURRENT_AFFILIATE_UPDATE,
  CURRENT_HASH_UPDATE,
} from "../constants/ActionTypes";
import * as type from "../constants/ActionTypes";

export default function affiliates(
  state = {
    isFetching: false,
    isAuthenticated: localStorage.getItem("id_token") ? true : false,
  },
  action
) {
  switch (action.type) {
    case AFFILIATES_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        isAuthenticated: false,
      });
    case AFFILIATES_SUCCESS:
      let response = [];
      if (action.response && action.response.length > 0) {
        action.response.forEach((aff) => {
          response.push({ ...aff, affiliate: { ...aff.affiliate } });
        });
      }

      let currentAffiliate;
      let currentHash;
      //if call comes from creation of new config, maintain current affiliate
      if (action.currentAffiliateId != null) {
        const aff = action.response.find((aff) => {
          if (aff.affiliate.affiliateId === action.currentAffiliateId) {
            return aff;
          }
          return false;
        });
        currentAffiliate = aff.affiliate;
        currentHash = aff.affiliate.affiliateExternalHashList[0].externalHashId;
      } else {
        currentAffiliate = response[0] ? response[0].affiliate : null;
        currentHash =
          response[0] && response[0].affiliate.affiliateExternalHashList[0]
            ? response[0].affiliate.affiliateExternalHashList[0].externalHashId
            : null;
      }

      return Object.assign({}, state, {
        isFetching: false,
        isAuthenticated: true,
        affiliatesList: response,
        currentAffiliate: currentAffiliate,
        currentHash: currentHash,
      });
    case AFFILIATES_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        isAuthenticated: false,
      });
    case CURRENT_AFFILIATE_UPDATE:
      return Object.assign({}, state, {
        currentAffiliate: action.currentAffiliate,
        currentHash:
          action.currentAffiliate.affiliateExternalHashList[0].externalHashId,
      });
    case CURRENT_HASH_UPDATE:
      return Object.assign({}, state, {
        currentHash: action.hash,
      });
    case type.AFFILIATE_MEMBER_REQUEST:
      return Object.assign({}, state, {
        membershipIsProcessing: true,
      });
    case type.AFFILIATE_MEMBER_SUCCESS:
      return Object.assign({}, state, {
        notification: {
          title: { id: "affiliate.success.title", defaultMessage: "Success" },
          status: "success",
          message: {
            id: "affiliate.success.message",
            defaultMessage:
              "Your membership request has been sent successfully",
          },
        },
        showNotification: true,
        membershipIsProcessing: false,
      });
    case type.AFFILIATE_MEMBER_FAILURE:
      console.log(action);
      return Object.assign({}, state, {
        notification: {
          title: { id: "affiliate.error.title", defaultMessage: "Error" },
          status: "danger",
          message: action.error.message,
        },
        showNotification: true,
        membershipIsProcessing: false,
      });
    case type.CLEAN_AFFILIATE_LIST:
      return Object.assign({}, state, {
        affiliatesList: [],
      });
    default:
      return state;
  }
}
